import { OTSubscriber } from 'opentok-react'
import React from 'react'

export default class Subscriber extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selected: true
		};
	}
	
	render () {
		return (
			<div>
				<OTSubscriber
					{...this.props}
					properties={{
						width: 500,
						height: 400
					}}
				/>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/Subscriber.js